<script lang="ts" setup>
import { useUnifiedLandingNav } from '~/composables/useUnifiedLandingNav';
import { EDUCATORS_ROUTE_LOGIN } from '~/constants/routes/educators';
import {
  UNIFIED_ROUTE_ADVISORS,
  UNIFIED_ROUTE_INDEX,
  UNIFIED_ROUTE_LEADERS,
  UNIFIED_ROUTE_REWARDS,
} from '~/constants/routes/unified';

const { t } = useI18n();
const { upperFooterLinks, lowerFooterLinks } = await useUnifiedLandingNav();
const { isUsa, isAus } = useClusterCountryConfig();
const accessibilityStore = useAccessibilityStore();

// The rewards landing is gated on the same flag as its page, so the link is dropped rather than
// pointing at a page that redirects away.
const { getFlag } = useFeatureFlags();
const schoolsRewardsPageEnabled = await getFlag('schools-rewards-page-enabled');

const navItems = [
  { label: t('schools.landing.nav.teachers'), to: UNIFIED_ROUTE_INDEX, imagePath: '/images/illustrations/envelope-blue.webp' },
  { label: t('schools.landing.nav.leaders'), to: UNIFIED_ROUTE_LEADERS, imagePath: '/images/illustrations/target.webp' },
  { label: t('schools.landing.nav.advisors'), to: UNIFIED_ROUTE_ADVISORS, imagePath: '/images/illustrations/colourful-books.webp' },
  ...(schoolsRewardsPageEnabled ? [{ label: t('schools.landing.nav.rewards'), to: UNIFIED_ROUTE_REWARDS, imagePath: '/images/illustrations/hearts-giftbox.webp' }] : []),
  { label: t('unified.nav.signIn'), to: EDUCATORS_ROUTE_LOGIN, isSecondary: true },
];
</script>

<template>
  <div class="min-h-screen overflow-x-clip bg-background flex flex-col gap-10">
    <KUICoreSkipToMainContentButton href="#main-content" />
    <KUIUnifiedLayoutPublicNav
      :nav-items="navItems"
      home-link="/"
      :logo-label="$t('unified.home')"
      logo-illustration="anyway-logo"
      :animations-enabled="accessibilityStore.animationsEnabled"
    >
      <template #secondary>
        <SchoolsSignInMenu />
      </template>
    </KUIUnifiedLayoutPublicNav>
    <main id="main-content" class="flex flex-col gap-30">
      <slot />
    </main>
    <KUICoreMainFooter
      :upper-links="upperFooterLinks"
      :lower-links="lowerFooterLinks"
      :copyright="$t('unified.footer.copyright')"
      logo-illustration="anyway-logo"
      :show-address-us="isUsa"
      :show-address-au="isAus"
    />
  </div>
</template>
